var exports = {
  "_": "xcc377c0b--71aa63--close-button",
};

module.exports = exports;
